import React, { useState, useEffect } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Typography,
  IconButton,
  TextField,
} from "@mui/material";
import { getData, postData } from "../../ServerRequest";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import GridViewIcon from "@mui/icons-material/GridView";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";

const buttonStyle = {
  background: "#f8f9fa",
  border: "3px solid #b0bec5",
  color: "black",
  fontSize: "0.850rem",
  "&:hover": { background: "#eceff1" },
  fontFamily: "Inter, sans-serif",
};

const sectionStyle = {
  backgroundColor: "rgba(255, 255, 255, 0.6)",
  marginBottom: 2,
  boxShadow: "0px 4px 8px rgba(0, 0, 1, 0.1)",
  fontFamily: "Inter, sans-serif",
};

const inputStyle = {
  "& .MuiInputBase-root": {
    height: 35,
    borderRadius: 0,
    backgroundColor: "white",
    fontFamily: "Inter, sans-serif",
  },
};

export default function LandingHeader() {
  const [header, setHeader] = useState([]);
  const [menu, setMenu] = useState([]);
  const [loading, setLoading] = useState();
  const [editIndex, setEditIndex] = useState({});

  const handleEditClick = (section, field) => {
    setEditIndex((prev) => ({ ...prev, [`${section}_${field}`]: true }));
  };

  const handleHeaderSubmit = async () => {
    let reqData = {
      'id': header.id ? header.id : "",
      'language_selection': header.language_selection ? header.language_selection : "",
      'logo': header.logo ? header.logo : "",
      'promotional_text': header.promotional_text ? header.promotional_text : "",
      'promotional_link': header.promotional_link ? header.promotional_link : "",
      'tracking_text': header.tracking_text ? header.tracking_text : "",
      'tracking_link': header.tracking_link ? header.tracking_link : "",
      'callback_text': header.callback_text ? header.callback_text : "",
      'callback_link': header.callback_link ? header.callback_link : "",
      'cart_link': header.cart_link ? header.cart_link : "",
      'wishlist_link': header.wishlist_link ? header.wishlist_link : "",
    };

    let headerResData = await postData("/api/app-setting/header-section/", reqData);
    console.log(headerResData);

    if (headerResData["data"]["code"] === 200) {
      alert("Header data saved successfully");
      setLoading(false);
      return true;
    } else {
      console.error("Header save error:", headerResData);
      alert(
        "Error saving header data: " +
          (headerResData.data?.message || JSON.stringify(headerResData))
      );
      setLoading(false);
    }
    return false;
  };

  const handleMenuSubmit = async () => {
    let menuReqData = menu.map((menuItem) => ({
      id: menuItem.id ? menuItem.id : "",
      name: menuItem.name ? menuItem.name : "",
      link_to: menuItem.link_to ? menuItem.link_to : "",
    }));

    let menuResData = await postData("/api/app-setting/app-menu/", menuReqData);
    if (menuResData["data"]["code"] === 200) {
      alert("Menu data saved successfully");
      setLoading(false);
      return true;
    } else {
      console.error("Menu save error:", menuResData);
      alert(
        "Error saving menu data: " +
          (menuResData.data?.message || JSON.stringify(menuResData))
      );
      setLoading(false);
    }
    return false;
  };

  useEffect(() => {
    async function fetchData() {
      let headerResData = await getData("/api/app-setting/header-section");
      console.log(headerResData);
      let header_data = headerResData["data"]["header"];
      if (header_data) {
        console.log(header_data);
        if (header_data) {
          setHeader(header_data);
        }
      } else {
        console.error("Error fetching header data:", headerResData.message);
      }

      let menuResData = await getData("/api/app-setting/app-menu");
      console.log(menuResData);
      let menu_data = menuResData["data"]["menus"];
      if (menu_data) {
        console.log(menu_data);
        setMenu(menu_data); // Correctly update the menu state
      } else {
        console.error("Error fetching menu data:", menuResData.message);
      }

      setLoading(false);
    }

    fetchData();
  }, []);

  return (
    <Box sx={{ width: "95%", paddingLeft: 3 }}>
      {/* Header Content Section */}
      <Accordion sx={sectionStyle}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <IconButton color="" component="icon">
              <GridViewIcon />
            </IconButton>
            <Typography variant="h7">Header Content</Typography>
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Box sx={{ backgroundColor: "#eceff1", padding: 4, borderRadius: 0 }}>
            <Typography variant="h6" sx={{ marginBottom: 2 }}>
              Content
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                marginBottom: 2,
                width: "100%",
              }}
            >
              <Box
                sx={{
                  display: "flex-col",
                  alignItems: "center",
                  marginRight: 2,
                  width: "50%",
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    color: "#424956",
                    fontFamily: "Inter",
                    fontWeight: 700,
                    fontSize: 14,
                  }}
                >
                  Language Selection
                </Typography>
                <TextField
                  fullWidth
                  sx={{ marginRight: 2, ...inputStyle }}
                  value={header.language_selection}
                  onChange={(e) =>
                    setHeader({ ...header, language_selection: e.target.value })
                  }
                  InputLabelProps={{ shrink: true }}
                  disabled={!editIndex["HeaderContent_languageSelection"]}
                />
              </Box>
              <Box
                sx={{
                  display: "flex-col",
                  alignItems: "center",
                  marginRight: 2,
                  width: "50%",
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    color: "#424956",
                    fontFamily: "Inter",
                    fontWeight: 700,
                    fontSize: 14,
                  }}
                >
                  Logo
                </Typography>
                <TextField
                  fullWidth
                  sx={{ marginRight: 0, ...inputStyle }}
                  value={header.logo}
                  onChange={(e) =>
                    setHeader({ ...header, logo: e.target.value })
                  }
                  InputLabelProps={{ shrink: true }}
                  disabled={!editIndex["HeaderContent_logo"]}
                />
              </Box>
              <IconButton
                sx={{ ml: 1, marginBottom: 1, color: "grey" }}
                onClick={() => {
                  handleEditClick("HeaderContent", "languageSelection");
                  handleEditClick("HeaderContent", "logo");
                }}
                aria-label="edit-content"
              >
                <EditOutlinedIcon />
              </IconButton>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                marginBottom: 2,
                width: "100%",
              }}
            >
              <Box
                sx={{
                  display: "flex-col",
                  alignItems: "center",
                  marginRight: 2,
                  width: "50%",
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    color: "#424956",
                    fontFamily: "Inter",
                    fontWeight: 700,
                    fontSize: 14,
                  }}
                >
                  Promotional Text
                </Typography>
                <TextField
                  fullWidth
                  sx={{ marginRight: 2, ...inputStyle }}
                  value={header.promotional_text}
                  onChange={(e) =>
                    setHeader({ ...header, promotional_text: e.target.value })
                  }
                  InputLabelProps={{ shrink: true }}
                  disabled={!editIndex["HeaderContent_promotionalText"]}
                />
              </Box>
              <Box
                sx={{
                  display: "flex-col",
                  alignItems: "center",
                  marginRight: 2,
                  width: "50%",
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    color: "#424956",
                    fontFamily: "Inter",
                    fontWeight: 700,
                    fontSize: 14,
                  }}
                >
                  Promotional Link
                </Typography>
                <TextField
                  fullWidth
                  sx={{ marginRight: 0, ...inputStyle }}
                  value={header.promotional_link}
                  onChange={(e) =>
                    setHeader({ ...header, promotional_link: e.target.value })
                  }
                  InputLabelProps={{ shrink: true }}
                  disabled={!editIndex["HeaderContent_promotionalLink"]}
                />
              </Box>
              <IconButton
                sx={{ ml: 1, marginBottom: 1, color: "grey" }}
                onClick={() => {
                  handleEditClick("HeaderContent", "promotionalText");
                  handleEditClick("HeaderContent", "promotionalLink");
                }}
                aria-label="edit-content"
              >
                <EditOutlinedIcon />
              </IconButton>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                marginBottom: 2,
                width: "100%",
              }}
            >
              <Box
                sx={{
                  display: "flex-col",
                  alignItems: "center",
                  marginRight: 2,
                  width: "50%",
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    color: "#424956",
                    fontFamily: "Inter",
                    fontWeight: 700,
                    fontSize: 14,
                  }}
                >
                  Tracking Text
                </Typography>
                <TextField
                  fullWidth
                  sx={{ marginRight: 2, ...inputStyle }}
                  value={header.tracking_text}
                  onChange={(e) =>
                    setHeader({ ...header, tracking_text: e.target.value })
                  }
                  InputLabelProps={{ shrink: true }}
                  disabled={!editIndex["HeaderContent_trackingText"]}
                />
              </Box>
              <Box
                sx={{
                  display: "flex-col",
                  alignItems: "center",
                  marginRight: 2,
                  width: "50%",
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    color: "#424956",
                    fontFamily: "Inter",
                    fontWeight: 700,
                    fontSize: 14,
                  }}
                >
                  Tracking Link
                </Typography>
                <TextField
                  fullWidth
                  sx={{ marginRight: 0, ...inputStyle }}
                  value={header.tracking_link}
                  onChange={(e) =>
                    setHeader({ ...header, tracking_link: e.target.value })
                  }
                  InputLabelProps={{ shrink: true }}
                  disabled={!editIndex["HeaderContent_trackingLink"]}
                />
              </Box>
              <IconButton
                sx={{ ml: 1, marginBottom: 1, color: "grey" }}
                onClick={() => {
                  handleEditClick("HeaderContent", "trackingText");
                  handleEditClick("HeaderContent", "trackingLink");
                }}
                aria-label="edit-content"
              >
                <EditOutlinedIcon />
              </IconButton>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                marginBottom: 2,
                width: "100%",
              }}
            >
              <Box
                sx={{
                  display: "flex-col",
                  alignItems: "center",
                  marginRight: 2,
                  width: "50%",
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    color: "#424956",
                    fontFamily: "Inter",
                    fontWeight: 700,
                    fontSize: 14,
                  }}
                >
                  Callback Text
                </Typography>
                <TextField
                  fullWidth
                  sx={{ marginRight: 2, ...inputStyle }}
                  value={header.callback_text}
                  onChange={(e) =>
                    setHeader({ ...header, callback_text: e.target.value })
                  }
                  InputLabelProps={{ shrink: true }}
                  disabled={!editIndex["HeaderContent_callbackText"]}
                />
              </Box>
              <Box
                sx={{
                  display: "flex-col",
                  alignItems: "center",
                  marginRight: 2,
                  width: "50%",
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    color: "#424956",
                    fontFamily: "Inter",
                    fontWeight: 700,
                    fontSize: 14,
                  }}
                >
                  Callback Link
                </Typography>
                <TextField
                  fullWidth
                  sx={{ marginRight: 0, ...inputStyle }}
                  value={header.callback_link}
                  onChange={(e) =>
                    setHeader({ ...header, callback_link: e.target.value })
                  }
                  InputLabelProps={{ shrink: true }}
                  disabled={!editIndex["HeaderContent_callbackLink"]}
                />
              </Box>
              <IconButton
                sx={{ ml: 1, marginBottom: 1, color: "grey" }}
                onClick={() => {
                  handleEditClick("HeaderContent", "callbackText");
                  handleEditClick("HeaderContent", "callbackLink");
                }}
                aria-label="edit-content"
              >
                <EditOutlinedIcon />
              </IconButton>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                marginBottom: 2,
                width: "100%",
              }}
            >
              <Box
                sx={{
                  display: "flex-col",
                  alignItems: "center",
                  marginRight: 2,
                  width: "50%",
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    color: "#424956",
                    fontFamily: "Inter",
                    fontWeight: 700,
                    fontSize: 14,
                  }}
                >
                  Cart Link
                </Typography>
                <TextField
                  fullWidth
                  sx={{ marginRight: 2, ...inputStyle }}
                  value={header.cart_link}
                  onChange={(e) =>
                    setHeader({ ...header, cart_link: e.target.value })
                  }
                  InputLabelProps={{ shrink: true }}
                  disabled={!editIndex["HeaderContent_cartLink"]}
                />
              </Box>
              <Box
                sx={{
                  display: "flex-col",
                  alignItems: "center",
                  marginRight: 2,
                  width: "50%",
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    color: "#424956",
                    fontFamily: "Inter",
                    fontWeight: 700,
                    fontSize: 14,
                  }}
                >
                  Wishlist Link
                </Typography>
                <TextField
                  fullWidth
                  sx={{ marginRight: 0, ...inputStyle }}
                  value={header.wishlist_link}
                  onChange={(e) =>
                    setHeader({ ...header, wishlist_link: e.target.value })
                  }
                  InputLabelProps={{ shrink: true }}
                  disabled={!editIndex["HeaderContent_wishlistLink"]}
                />
              </Box>
              <IconButton
                sx={{ ml: 1, marginBottom: 1, color: "grey" }}
                onClick={() => {
                  handleEditClick("HeaderContent", "cartLink");
                  handleEditClick("HeaderContent", "wishlistLink");
                }}
                aria-label="edit-content"
              >
                <EditOutlinedIcon />
              </IconButton>
            </Box>
            <IconButton
              variant="contained"
              sx={{ ...buttonStyle, marginRight: 3, marginTop: 2 }}
              aria-label="save-changes"
              onClick={handleHeaderSubmit}
            >
              <SaveOutlinedIcon />
            </IconButton>
          </Box>
        </AccordionDetails>
      </Accordion>

      {/* Menu Items Section */}
      <Accordion sx={sectionStyle}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <IconButton color="" component="icon">
              <GridViewIcon />
            </IconButton>
            <Typography variant="h7">Menu Items</Typography>
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Box sx={{ backgroundColor: "#eceff1", padding: 4, borderRadius: 0 }}>
            <Typography variant="h6" sx={{ marginBottom: 2 }}>
              App Menu
            </Typography>
            {menu.map((menuItem, index) => (
              <Box
                key={menuItem.id}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: 2,
                  width: "100%",
                }}
              >
                <Box
                  sx={{
                    display: "flex-col",
                    alignItems: "center",
                    marginRight: 2,
                    width: "50%",
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{
                      color: "#424956",
                      fontFamily: "Inter",
                      fontWeight: 700,
                      fontSize: 14,
                    }}
                  >
                    Name
                  </Typography>
                  <TextField
                    fullWidth
                    sx={{ marginRight: 2, ...inputStyle }}
                    value={menuItem.name}
                    onChange={(e) => {
                      const updatedMenu = [...menu];
                      updatedMenu[index].name = e.target.value;
                      setMenu(updatedMenu);
                    }}
                    InputLabelProps={{ shrink: true }}
                    disabled={!editIndex[`MenuItem_name_${index}`]}
                  />
                </Box>
                <Box
                  sx={{
                    display: "flex-col",
                    alignItems: "center",
                    marginRight: 2,
                    width: "50%",
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{
                      color: "#424956",
                      fontFamily: "Inter",
                      fontWeight: 700,
                      fontSize: 14,
                    }}
                  >
                    Link to
                  </Typography>
                  <TextField
                    fullWidth
                    sx={{ marginRight: 0, ...inputStyle }}
                    value={menuItem.link_to}
                    onChange={(e) => {
                      const updatedMenu = [...menu];
                      updatedMenu[index].link_to = e.target.value;
                      setMenu(updatedMenu);
                    }}
                    InputLabelProps={{ shrink: true }}
                    disabled={!editIndex[`MenuItem_linkTo_${index}`]}
                  />
                </Box>
                <IconButton
                  sx={{ ml: 1, marginBottom: 1, color: "grey" }}
                  onClick={() => {
                    handleEditClick("MenuItem", `name_${index}`);
                    handleEditClick("MenuItem", `linkTo_${index}`);
                  }}
                  aria-label="edit-content"
                >
                  <EditOutlinedIcon />
                </IconButton>
              </Box>
            ))}
            <IconButton
              variant="contained"
              sx={{ ...buttonStyle, marginRight: 3, marginTop: 2 }}
              aria-label="save-changes"
              onClick={handleMenuSubmit}
            >
              <SaveOutlinedIcon />
            </IconButton>
          </Box>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
